export default ({keys, server}) => `package com.stripe.example;

import com.stripe.stripeterminal.callable.BluetoothReaderListener;
import com.stripe.stripeterminal.callable.Cancelable;
import com.stripe.stripeterminal.model.external.ReaderDisplayMessage;
import com.stripe.stripeterminal.model.external.ReaderInputOptions;
import com.stripe.stripeterminal.model.external.ReaderEvent;
import com.stripe.stripeterminal.model.external.ReaderSoftwareUpdate;
import com.stripe.stripeterminal.model.external.TerminalException;

import org.jetbrains.annotations.NotNull;
import org.jetbrains.annotations.Nullable;

public class TerminalBluetoothReaderListener implements BluetoothReaderListener {
    @Override
    public void onRequestReaderInput(@NotNull ReaderInputOptions readerInputOptions) {
    }

    @Override
    public void onRequestReaderDisplayMessage(@NotNull ReaderDisplayMessage readerDisplayMessage) {
    }

    @Override
    public void onStartInstallingUpdate(@NotNull ReaderSoftwareUpdate update, @NotNull Cancelable cancelable) {
        // Show UI communicating that a required update has started installing
    }

    @Override
    public void onReportReaderSoftwareUpdateProgress(float progress) {
        // Update the progress of the install
    }

    @Override
    public void onFinishInstallingUpdate(@Nullable ReaderSoftwareUpdate update, @Nullable TerminalException e) {
        // Report success or failure of the update
    }
}
`;
